import {mapActions, mapMutations, mapState} from "vuex"
import {BranchDetails} from "../../../wl-core/api/classes/BranchDetails"

export default {

    props: {
        id: {
            type: String,
            default: () => this.$route.params.id
        },
        building: BranchDetails
    },
    created() {
        if (this.$route.params.id) {
            this.getBranchDetails(this.$route.params.id)
        } else if (this.id) {
            this.getBranchDetails(this.id)
        } else if (this.building) {
            this.setBranchDetails(this.building)
        }
    },
    computed: {
        ...mapState('branch', [
            'branchDetails'
        ])
    },
    methods: {
        ...mapActions('branch', [
            'getBranchDetails'
        ]),
        ...mapMutations('branch', [
                'setBranchDetails'
            ]
        )
    }


}
